import { useTranslation } from 'react-i18next';
import { Link } from 'wouter';
import PageHeader from '~/components/PageHeader';
import Button from '~/components/ui/Button';
import { CardBox } from '~/components/ui/Card';
import Icon from '~/components/ui/Icon';
import SettingsRow from '~/components/ui/SettingsRow';
import Stack from '~/components/ui/Stack';
import useGDPR from '~/modules/user/useGDPR';

function DataManagement() {
  const { t } = useTranslation();
  const { isPending, mutate: download } = useGDPR();

  return (
    <Stack col gap={4} className="compact:gap-5 compact:[&_h2]:text-[13px] compact:[&_h2]:mb-2.5">
      <PageHeader id="dataManagement" />

      <section>
        <h2 className="mb-3 font-sans text-sm font-semibold text-section-title">
          {t('dataManagement.downloadTitle')}
        </h2>
        <CardBox className="flex flex-wrap items-center gap-6 p-8 compact:p-4 compact:gap-4">
          <div className="flex min-w-0 grow shrink basis-70 items-center gap-8 compact:basis-50 compact:gap-3">
            <span className="grid size-13 shrink-0 place-items-center rounded-full bg-icon-background compact:size-10">
              <Icon name="database" className="text-[26px] text-icon" />
            </span>
            <dl className="m-0 flex flex-wrap gap-12 max-phone:gap-7">
              <div>
                <dt className="mb-2.5 text-[13px] text-gray-3">
                  {t('dataManagement.format.label')}:
                </dt>
                <dd className="m-0 text-[15px]">{t('dataManagement.format.value')}</dd>
              </div>
              <div>
                <dt className="mb-2.5 text-[13px] text-gray-3">
                  {t('dataManagement.dateRange.label')}:
                </dt>
                <dd className="m-0 text-[15px]">{t('dataManagement.dateRange.value')}</dd>
              </div>
            </dl>
          </div>
          <div className="ml-auto flex shrink-0 justify-end">
            <Button className="gap-2" onPress={() => download()} isPending={isPending}>
              {t('dataManagement.download')}
              <Icon name="upload" className="text-[18px] rotate-180" />
            </Button>
          </div>
        </CardBox>
      </section>

      <section>
        <h2 className="mb-3 font-sans text-sm font-semibold text-section-title">
          {t('dataManagement.deletionTitle')}
        </h2>
        <SettingsRow
          as={Link}
          href="/data-management/account-deletion"
          icon="close"
          label={t('dataManagement.deleteAccount')}
          value={t('dataManagement.deleteAccountDescription')}
          danger
          standalone
        />
      </section>
    </Stack>
  );
}

export default DataManagement;
